import { AxiosError } from "axios";
import { useSetAtom } from "jotai";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Intent, IntentSentence, IntentSentenceUpdate } from "@/model";
import sentenceRepository from "@/repository/sentenceRepository";
import { intentQueryKeys } from "@/query/intent";
import { intentTableRefetchAtom } from "@/atom/intentTable";


export const useUpdateIntentSentence = (
    agentId: number, skillId?: number, intentId?: string, sentenceKey?: string
) => {
    const queryClient = useQueryClient();
    const setIntentTableRefetch = useSetAtom(intentTableRefetchAtom);

    return useMutation<IntentSentence, AxiosError, IntentSentenceUpdate>({
        mutationKey: ["intent-sentence", "agent", agentId, "skill", skillId, "intent", intentId, "sentenceKey", sentenceKey, "update"],
        mutationFn: async (body: IntentSentenceUpdate) => {
            try {
                const { data } = await sentenceRepository.update(agentId, skillId!, intentId!, sentenceKey!, body);
                return data.data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async (newIntentSentence) => {
            const intents = await queryClient.getQueryData(intentQueryKeys.intents(agentId, skillId)) as Intent[];

            intents.forEach(intent => {
                if (intent.id === intentId) {
                    intent.sentences = intent.sentences.map(sentence => sentence.key === sentenceKey ? newIntentSentence : sentence);
                }
            });
            setIntentTableRefetch(true);
        }
    });
};
